export default __webpack_public_path__ + "static/media/twitter.4ba90bea.svg";